import {Observable} from 'rxjs';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';

export class User {

    constructor() {
    }

    public email: string;
    public family_name: string;
    public given_name: string;
    public name: string;
    public groupsid: any[];
    public realm_access: string[];
    public resource_access: string[];
    public access_token_azure: string;
    public ProfilePhoto: string;
    public promiseProfilePhoto: Promise<string>;
    public azure_id: string;
    public lang: string;
    public userOrGroupId: number;

    public static getUserInSession(): User {
        const result = new User();
        const json = JSON.parse(localStorage.getItem('currentUser'));

        result.email = (json['email']) ? json['email'] : '';
        result.family_name = (json['family_name']) ? json['family_name'] : '';
        result.given_name = (json['given_name']) ? json['given_name'] : '';
        result.name = (json['name']) ? json['name'] : '';
        result.realm_access = (json['realm_access']) ? json['realm_access'] : '';
        result.resource_access = (json['resource_access']) ? json['resource_access'] : '';
        result.azure_id = (json['azure_id']) ? json['azure_id'] : '';
        return result;
    }

    public fromJsonKeyCloak(json: Object) {
        this.email = json['email'];
        this.family_name = json['lastName'];
        this.given_name = json['firstName'];
        this.name =  json['firstName'] + ' ' + json['lastName'];
        this.realm_access = json['realm_access'];
        this.resource_access = json['resource_access'];
    }

    public fromJsonAzure(json: Object) {
        this.access_token_azure = json['access_token'];
    }

    public deleteUserInSession() {
        localStorage.removeItem('currentUser');
    }

}
